import crypto from "crypto-browserify" 

export default (text) => {
  var decipher = crypto.createDecipheriv(process.env.ENCRYPT_ALGO, Buffer.from(process.env.ENCRYPT_KEY), Buffer.from(process.env.ENCRYPT_VECTOR))
  var dec = decipher.update(text,'hex','utf8')
  dec += decipher.final('utf8')
  return dec
}
